// =====================================================
// CONFIGURAZIONE API
// =====================================================

// URL base del backend PHP
// In sviluppo: usa il backend remoto su OVH (ora in /shop/backend)
// In produzione: usa il percorso relativo (shop è in /shop, backend in /shop/backend)
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/shop/backend/api' 
  : 'http://efwypvu.cluster021.hosting.ovh.net/shop/backend/api';

// Funzione helper per le chiamate API
async function apiCall(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    
    // Debug temporaneo per vedere cosa restituisce il server
    console.log('Response status:', response.status);
    console.log('Response ok:', response.ok);
    
    const responseText = await response.text();
    console.log('Response text:', responseText);
    
    if (!response.ok) {
      throw new Error(`Server error ${response.status}: ${responseText}`);
    }
    
    const data = JSON.parse(responseText);

    if (!data.success) {
      throw new Error(data.error || 'Errore nella richiesta');
    }

    return data.data;
  } catch (error) {
    console.error('Errore API:', error);
    throw error;
  }
}

// =====================================================
// API PRODOTTI
// =====================================================

export const prodottiAPI = {
  // GET tutti i prodotti
  getAll: async () => {
    return await apiCall('/prodotti.php');
  },

  // GET singolo prodotto
  getById: async (id) => {
    return await apiCall(`/prodotti.php?id=${id}`);
  },

  // GET prodotti per categoria
  getByCategoria: async (categoriaId) => {
    return await apiCall(`/prodotti.php?categoria=${categoriaId}`);
  },

  // POST nuovo prodotto
  create: async (prodotto) => {
    return await apiCall('/prodotti.php', {
      method: 'POST',
      body: JSON.stringify(prodotto),
    });
  },

  // PUT aggiorna prodotto
  update: async (id, prodotto) => {
    return await apiCall('/prodotti.php', {
      method: 'PUT',
      body: JSON.stringify({ id, ...prodotto }),
    });
  },

  // DELETE elimina prodotto
  delete: async (id) => {
    return await apiCall(`/prodotti.php?id=${id}`, {
      method: 'DELETE',
    });
  },
};

// =====================================================
// API CATEGORIE
// =====================================================

export const categorieAPI = {
  // GET tutte le categorie
  getAll: async () => {
    return await apiCall('/categorie.php');
  },

  // POST nuova categoria
  create: async (categoria) => {
    return await apiCall('/categorie.php', {
      method: 'POST',
      body: JSON.stringify(categoria),
    });
  },
};

// =====================================================
// API ORDINI
// =====================================================

export const ordiniAPI = {
  // GET tutti gli ordini
  getAll: async () => {
    return await apiCall('/ordini.php');
  },

  // GET singolo ordine
  getById: async (id) => {
    return await apiCall(`/ordini.php?id=${id}`);
  },

  // POST nuovo ordine
  create: async (ordine) => {
    return await apiCall('/ordini.php', {
      method: 'POST',
      body: JSON.stringify(ordine),
    });
  },
  
  // PUT aggiorna stato pagato
  updatePagato: async (id_ordine, pagato = 1) => {
    return await apiCall('/ordini.php', {
      method: 'PUT',
      body: JSON.stringify({ id_ordine, pagato }),
    });
  },
};

// =====================================================
// API NEXI
// =====================================================

export const nexiAPI = {
  // POST crea ordine Nexi (Hosted Payment Page)
  createOrder: async (orderData) => {
    return await apiCall('/nexi.php?action=create', {
      method: 'POST',
      body: JSON.stringify(orderData),
    });
  },

  // POST verifica stato ordine Nexi
  checkStatus: async (orderId) => {
    return await apiCall('/nexi.php?action=check', {
      method: 'POST',
      body: JSON.stringify({ order_id: orderId }),
    });
  },
};

// =====================================================
// API IMPOSTAZIONI
// =====================================================

export const settingsAPI = {
  getShipping: async () => {
    return await apiCall('/settings.php');
  },
  updateShipping: async (settings) => {
    return await apiCall('/settings.php', {
      method: 'PUT',
      credentials: 'include',
      body: JSON.stringify(settings),
    });
  },
};

export default {
  prodotti: prodottiAPI,
  categorie: categorieAPI,
  ordini: ordiniAPI,
  nexi: nexiAPI,
  settings: settingsAPI,
};

